module.exports = "https://cdn2-fs.clearscore.com/flux/images/9dddbc7227b858c54a18abb5ef1e5a9a.jpg";